import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all, fetch_all_with_count, fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
import { currentPracticeAtom } from '../../../lib/practice';

import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import LinkIcon from '@mui/icons-material/Link';

import {
  Alert,
  Button as Btn,
  CircularProgress,
  DialogActions,
  Grid,
} from '@mui/material';

import {
  Button,
  Page,
  Typography
} from '../../../components/v2/styled';
import { Base } from '../../../components/v2/dialogs/Base';
import { CoachShowQuestionnaire } from '../../../components/v2/dialogs/CoachShowQuestionnaire';
import { Premium } from '../../../components/v2/dialogs/Premium';
import { SnackSaved } from '../../../components/v2/snacks/Saved';

import { Appointment } from '../../../models/Appointment';
import { QuestionnaireResult } from '../../../models/QuestionnaireResult';
import { User } from '../../../models/User';

import HelpersPractice from '../../../actions/helpers/practice';
import { CoachUserWidgetsPictureAndTags } from './widgets/PictureAndTags';
import { CoachUserWidgetsConsentInformation } from './widgets/ConsentInformation';
import { CoachUserWidgetsAccountManagement } from './widgets/AccountManagement';
import { CoachUserWidgetsNotificationInformation } from './widgets/NotificationInformation';
import { CoachUserWidgetsCoursesSmall } from './widgets/CoursesSmall';
import { CoachUserWidgetsMollieLinksSmall } from './widgets/MollieLinksSmall';
import { CoachUserWidgetsWeightTrigger } from './widgets/WeightTrigger';
import { CoachUserWidgetsDetailsBasic } from './widgets/DetailsBasic';
import { CoachUserWidgetsDetailsContact } from './widgets/DetailsContact';
import { CoachUserWidgetsDetailsExtra } from './widgets/DetailsExtra';
import { CoachUserWidgetsAppointmentsSmall } from './widgets/AppointmentsSmall';
import { CoachUserWidgetsCommunicationSmall } from './widgets/CommunicationSmall';
import { CoachUserWidgetsFileSmall } from './widgets/FileSmall';
import { CoachUserWidgetsDiarySmall } from './widgets/DiarySmall';
import { CoachUserWidgetsMeasuresSmall } from './widgets/MeasuresSmall';
import { CoachUserWidgetsQuestionnairesSmall } from './widgets/QuestionnairesSmall';
import { CoachUserWidgetsBasicIntake } from './widgets/BasicIntake';
import { CoachUserWidgetsBasicTreatment } from './widgets/BasicTreatment';
import { CoachUserWidgetsBasicMeasureUploads } from './widgets/BasicMeasureUploads';
import { CoachUserWidgetsBasicAdviceUploads } from './widgets/BasicAdviceUploads';
import { CoachUserWidgetsBasicAdvice } from './widgets/BasicAdvice';
import { CoachUserWidgetsTimeline } from './widgets/Timeline';
import { CoachUserWidgetsStatus } from './widgets/Status';
import { CoachUserWidgetsInternalComment } from './widgets/InternalComment';
import { CoachUserWidgetsBasicSleep } from './widgets/BasicSleep';
import { CoachUserWidgetsWorkshops } from './widgets/Workshops';
import { CoachUserWidgetsBaseMapper } from './widgets/BaseMapper';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const { DateTime } = require("luxon");

type Props = {}

export const CoachUserDetail: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  const params = useParams();
  // const queryClient = useQueryClient();
  const { state } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  
  const [objectId, setObjectId] = useState<string | undefined>(params.id);
  const [clientId, setClientId] = useState<string>();
  const [practiceKey, setPracticeKey] = useState<string>();
  const [premiumEhealthOpen, setPremiumEhealthOpen] = useState<boolean>(false);
  const [premiumZorgmailOpen, setPremiumZorgmailOpen] = useState<boolean>(false);
  const [premiumNutriMailOpen, setPremiumNutriMailOpen] = useState<boolean>(false);
  const [premiumNutriAdviceOpen, setPremiumNutriAdviceOpen] = useState<boolean>(false);
  const [premiumDiaryEatOpen, setPremiumDiaryEatOpen] = useState<boolean>(false);
  const [premiumDiaryMoveOpen, setPremiumDiaryMoveOpen] = useState<boolean>(false);
  const [premiumNutriAppointmentOpen, setPremiumNutriAppointmentOpen] = useState<boolean>(false);
  const [premiumQuestionnaireOpen, setPremiumQuestionnaireOpen] = useState<boolean>(false);
  const [premiumKnowledgeOpen, setPremiumKnowledgeOpen] = useState<boolean>(false);
  const [premiumMeasuresWeightOpen, setPremiumMeasuresWeightOpen] = useState<boolean>(false);
  const [premiumPaymentsOpen, setPremiumPaymentsOpen] = useState<boolean>(false);
  const [passResetLink, setPassResetLink] = useState<string>();
  const [passResetEmail, setPassResetEmail] = useState<string>();
  const [consentAsked, setConsentAsked] = useState<string>();
  const [qResultOpen, setQResultOpen] = useState<boolean>(!!state?.open_q);
  const [activeQResult, setActiveQResult] = useState<number|undefined>(!!state?.open_q ? state.open_q : undefined);
  const [savedOpen, setSavedOpen] = useState<boolean>(false);
  const [newEpisodeWarningOpen, setNewEpisodeWarningOpen] = useState<boolean>(false);
  // const [mainObject, setMainObject] = useState<User>({
  //   auth_token: '',
  //   email: '',
  //   coach_skills: []
  // });
  const [newEatGroup, setNewEatGroup] = useState<string>();
  const [newMoveGroup, setNewMoveGroup] = useState<string>();
  const [groupsEatEditing, setGroupsEatEditing] = useState<boolean>(false);
  const [groupsMoveEditing, setGroupsMoveEditing] = useState<boolean>(false);
  // const [invitation, setInvitation] = useState<boolean>(false);
  // const [activeQ, setActiveQ] = useState<Questionnaire>();

  const [ehealthInitOpen, setEhealthInitOpen] = useState<boolean>(false);
  const [zorgmailInitOpen, setZorgmailInitOpen] = useState<boolean>(false);

  let soonCount = 0;
  let futureCount = 0;

  let is_questionnaire = HelpersPractice.practice_modules_v3({practice: currentPractice, check: 'questionnaire'});

  const {
    data: object,
    isLoading: objectLoading,
    isError: objectError,
    isSuccess: objectSuccess,
    refetch: objectRefetch,
  } = useQuery({
    queryKey: ["user", 'full', (login?.practice_id || currentPractice?.id), objectId, clientId, practiceKey],
    queryFn: () =>
      fetch_one<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'user',
          id: objectId,
          client_id: clientId,
          practice_key: practiceKey,
          fields: [
            'id', 'first_name', 'second_name', 'last_name', 'email', 'consent_status', 'call_name', 'birth_date', 'language_id', 'gender',
            'phone_fixed', 'phone_mobile', 'street', 'number', 'zip', 'city', 'country_id', 'spouse_name', 'national_number', 'get_medium',
            'full_fm_links', 'settings', 'country|id/name', 'module_status', 'full_eat_groups', 'full_move_groups', 'merge_pending', 'mfa_status', 'created_at', 'last_sign_in_at',
            'questionnaire_results', 'extra_data', 'intake_profile', 'intake_profile_practice', 'intake_profiles_practice', 'practice_advices_count', 'advice_uploads|count', 'episode',
            'episodes', 'last_appointment', 'user_tags', 'type', 'consents', 'adh_profile_id', 'calculated_adh_profile_id'
          ],
          sub_fields: {
            'questionnaire_results': ['id', 'questionnaire_id', 'extra_data', 'completed_at', 'invited_at', 'mail_sent_at', 'is_locked', 'comment'],
            'intake_profile': ['id', 'updated_at', 'created_at'],
            'intake_profile_practice': ['id', 'updated_at', 'created_at', 'editor|id/full_name', 'consult_reason'],
            'consents': ['id', 'practice_id', 'enabled', 'adh_profile_id']
          },
          practice_id: (login?.practice_id || currentPractice?.id),
          only_one: 1
        },
        login
      ),
    select: (d) => {
      return {
        ...d,
        birth_date: !!d.birth_date ? DateTime.fromISO(d.birth_date).toFormat("dd/LL/y") : undefined
      };
    },
    enabled: !!(login?.practice_id || currentPractice?.id) && ((parseInt(objectId || '', 10) > 0) || (!!clientId && !!practiceKey)),
  });

  const {
    data: appointmentsSoon,
    isLoading: appointmentsSoonLoading,
    isError: appointmentsSoonError,
    isSuccess: appointmentsSoonSuccess,
    refetch: appointmentsSoonRefetch,
  } = useQuery({
    queryKey: ["appointments_soon", login?.id],
    queryFn: () =>
      fetch_all_with_count<Appointment>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'appointment',
          fields: [
            'id'
          ],
          page: 0,
          per_page: 1,
          order: "start_time ASC",
          filter: {
            search: '',
            advanced: {
              user_id: object?.id,
              practice_id: currentPractice?.id,
              soon: 1
            }
          }
        },
        login
      ),
      select: (d) => {
        soonCount = d.count;
        return d.result;
      },
    enabled: !!object && object.type === "User::User",
  });
  const {
    data: appointmentsFuture,
    isLoading: appointmentsFutureLoading,
    isError: appointmentsFutureError,
    isSuccess: appointmentsFutureSuccess,
    refetch: appointmentsFutureRefetch,
  } = useQuery({
    queryKey: ["appointments_future", login?.id],
    queryFn: () =>
      fetch_all_with_count<Appointment>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'appointment',
          fields: [
            'id'
          ],
          page: 0,
          per_page: 1,
          order: "start_time ASC",
          filter: {
            search: '',
            advanced: {
              user_id: object?.id,
              practice_id: currentPractice?.id,
              future: 1
            }
          }
        },
        login
      ),
      select: (d) => {
        futureCount = d.count;
        return d.result;
      },
    enabled: !!object && object.type === "User::User",
  });



  
  
  
  // const {
  //   data: questionnaires,
  //   // isLoading: objectsLoading,
  //   // isError: objectsError,
  //   // isSuccess: objectsSuccess,
  //   // refetch: objectsRefetch,
  // } = useQuery({
  //   queryKey: ["coach", "questionnaires_short", (login?.practice_id || currentPractice?.id)],
  //   queryFn: () =>
  //     fetch_all<Questionnaire>(
  //       `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
  //       {
  //         object: 'questionnaire',
  //         fields: ['id', 'name'],
  //         order: "id DESC",
  //         per_page: 20,
  //         page: 0,
  //         filter: {
  //           search: '',
  //           advanced: {
  //             practice_id: (login?.practice_id || currentPractice?.id)
  //           }
  //         },
  //         practice_id: (login?.practice_id || currentPractice?.id)
  //       },
  //       login
  //     ),
  //   enabled: !!(login?.practice_id || currentPractice?.id) && !!is_questionnaire,
  // });
  const {
    data: questionnaireResult,
    // isLoading: objectLoading,
    // isError: objectError,
    // isSuccess: objectSuccess,
    refetch: questionnaireResultRefetch,
  } = useQuery({
    queryKey: ["questionnaire_result", (login?.practice_id || currentPractice?.id), activeQResult],
    queryFn: () =>
      fetch_one<QuestionnaireResult>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'questionnaire_result',
          id: activeQResult,
          fields: [
            'id', 'name', 'extra_data', 'questionnaire', 'practice', 'comment', 'is_locked'
          ],
          sub_fields: {
            'practice': ['id', 'name'],
            'questionnaire': ['id', 'name', 'extra_data']
          },
          practice_id: (login?.practice_id || currentPractice?.id)
        },
        login
      ),
    // select: (d) => {
    //   return {
    //     ...d,
    //     birth_date: DateTime.fromISO(d.birth_date).toFormat("dd/LL/y")
    //   };
    // },
    enabled: !!(login?.practice_id || currentPractice?.id) && !!activeQResult && !!is_questionnaire,
  });
  
  







  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
      pass?: boolean;
      consent?: boolean;
      group?: boolean;
      unlink?: boolean;
      mfa?: boolean;
      start_download?: boolean;
    }) => {
      return fetch_one<{custom_result: {success?: boolean; url?: string; email?: string;}}>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      if (variables.pass) {
        setPassResetLink(data.custom_result.url);
        setPassResetEmail(data.custom_result.email);
      }
      if (variables.consent) setConsentAsked(data.custom_result.success ? 'asked' : 'error');
      if (variables.group) {
        setGroupsEatEditing(false);
        setGroupsMoveEditing(false);
        setNewEatGroup(undefined);
        setNewMoveGroup(undefined);
        objectRefetch();
      }
      if (variables.unlink) {
        navigate('/users');
      }
      if (variables.mfa) {
        objectRefetch();
      }
      if (variables.start_download && data.custom_result) {
        // create file in browser
        const fileName = "user_data";
        const json = JSON.stringify(data.custom_result, null, 2);
        const blob = new Blob([json], { type: "application/json" });
        const href = URL.createObjectURL(blob);

        // create "a" HTLM element with href to file
        const link = document.createElement("a");
        link.href = href;
        link.download = fileName + ".json";
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      }
    },
  });
  // const mutationSave = useMutation({
  //   mutationFn: (pars: {
  //     formData: any;
  //     keepOpen?: boolean
  //   }) => {
  //     return fetch_one<QuestionnaireResult>(
  //       `/${i18n.resolvedLanguage || 'nl'}/v3/objects/save`,
  //       pars.formData,
  //       login
  //     );
  //   },
  //   onMutate: (pars: {
  //     formData: any;
  //   }) => {
  //     return true;
  //   },
  //   onError: (data, variables, context) => {
  //     return true;
  //   },
  //   onSuccess: (data, variables, context) => {
  //     objectRefetch();
  //   },
  // });






  useEffect(() => {
    if (params.id !== 'new') objectRefetch();
  }, [params.id]);
  useEffect(() => {
    setClientId(searchParams.get("client_id") || undefined);
  }, [searchParams.get("client_id")]);
  useEffect(() => {
    setPracticeKey(searchParams.get("practice_key") || undefined);
  }, [searchParams.get("practice_key")]);

  return <Page
    title={(object || {}).first_name}
    titleCrumbs={[
      {
        title: t("coach.menu.users", "Cliënten"),
        path: "/users"
      }
    ]}
  >
    {!!objectLoading && <Grid container spacing={1}>
      <Grid item xs={12} sx={{textAlign: 'center'}}>
        <CircularProgress />
      </Grid>
    </Grid>}
    {!!objectSuccess && <Grid container spacing={1}>
      {/* {(object?.consents || []).filter(fff => fff.practice_id === currentPractice?.id || fff.practice_id === login?.practice_id).length < 1} */}


      {!!object.extra_data?.is_guest && <Grid item xs={12}>
        <Alert severity='info'>
          <Typography>{t("coach.models.clients.is_guest_extended")}</Typography>
        </Alert>
      </Grid>}
      {object.email.indexOf("accountclosed") > -1 && <Grid item xs={12}>
        <Alert severity='error'>
          <Typography>{t("coach.models.clients.is_closed_account")}</Typography>
        </Alert>
      </Grid>}
      {object?.type !== "User::User" && <Grid item xs={12}>
        <Alert severity='error'>
          <Typography>{t("coach.models.clients.is_not_a_client")}</Typography>
        </Alert>
      </Grid>}
      {!!object.extra_data?.weight_trigger && <Grid item xs={12}>
        <Alert severity='info'>
          <Typography>{t("coach.models.clients.is_weight_trigger")}</Typography>
        </Alert>
      </Grid>}

      {(object.extra_data?.disabled_notifications?.new_episode || []).indexOf(currentPractice?.id || 0) < 0 && (futureCount + soonCount) > 0 && !!object?.last_appointment && DateTime.fromISO(object?.last_appointment).diffNow('years').years < -1 && <Grid item xs={12}>
        <Alert severity='info'>
          <Typography>{t("coach.models.clients.new_episode_hint")}</Typography>
          <Button
            id="increase_episode_sm"
            sx={{marginTop: 1}}
            contained
            size="small"
            onClick={(e) => {
              setNewEpisodeWarningOpen(true);
            }}
            startIcon={<KeyboardDoubleArrowUpIcon />}
            label={t("coach.submenu.detail_episodes.cta_new_episode")}
          />
          <Button
            id="hide_notification"
            sx={{marginTop: 1, marginLeft: 1}}
            text
            size="small"
            onClick={(e) => {
              mutationCustomAction.mutate({
                formData: {
                  object: 'user',
                  class_action: 'custom_api_disable_notification',
                  id: object?.id,
                  practice_id: (login?.practice_id || currentPractice?.id),
                  notification_type: 'new_episode'
                },
                mfa: true
              });
            }}
            startIcon={<VisibilityOff />}
            label={t("coach.submenu.cta.hide_notification")}
          />
        </Alert>
      </Grid>}








      {!!login?.settings?.userdetail_widgets && <>
        <Grid item xs={12} md={4}>
          {(login?.settings?.userdetail_widgets.left_col || []).map(cl => <CoachUserWidgetsBaseMapper
            cl={cl}
            object={object}
            setPremiumEhealthOpen={setPremiumEhealthOpen}
            setPremiumZorgmailOpen={setPremiumZorgmailOpen}
            setPremiumNutriMailOpen={setPremiumNutriMailOpen}
            setEhealthInitOpen={setEhealthInitOpen}
            setZorgmailInitOpen={setZorgmailInitOpen}
            objectRefetch={objectRefetch}
            mutationCustomAction={mutationCustomAction}
            passResetLink={passResetLink}
            passResetEmail={passResetEmail}
            setPremiumPaymentsOpen={setPremiumPaymentsOpen}
            setPremiumDiaryEatOpen={setPremiumDiaryEatOpen}
            setPremiumDiaryMoveOpen={setPremiumDiaryMoveOpen}
            groupsEatEditing={groupsEatEditing}
            setGroupsEatEditing={setGroupsEatEditing}
            groupsMoveEditing={groupsMoveEditing}
            setGroupsMoveEditing={setGroupsMoveEditing}
            newEatGroup={newEatGroup}
            setNewEatGroup={setNewEatGroup}
            newMoveGroup={newMoveGroup}
            setNewMoveGroup={setNewMoveGroup}
            consentAsked={consentAsked}
            setPremiumNutriAdviceOpen={setPremiumNutriAdviceOpen}
            setNewEpisodeWarningOpen={setNewEpisodeWarningOpen}
            setPremiumNutriAppointmentOpen={setPremiumNutriAppointmentOpen}
            setPremiumMeasuresWeightOpen={setPremiumMeasuresWeightOpen}
            setPremiumQuestionnaireOpen={setPremiumQuestionnaireOpen}
            setPremiumKnowledgeOpen={setPremiumKnowledgeOpen}
          />)}
        </Grid>
        <Grid item xs={12} md={4}>
          {(login?.settings?.userdetail_widgets.mid_col || []).map(cl => <CoachUserWidgetsBaseMapper
            cl={cl}
            object={object}
            setPremiumEhealthOpen={setPremiumEhealthOpen}
            setPremiumZorgmailOpen={setPremiumZorgmailOpen}
            setPremiumNutriMailOpen={setPremiumNutriMailOpen}
            setEhealthInitOpen={setEhealthInitOpen}
            setZorgmailInitOpen={setZorgmailInitOpen}
            objectRefetch={objectRefetch}
            mutationCustomAction={mutationCustomAction}
            passResetLink={passResetLink}
            passResetEmail={passResetEmail}
            setPremiumPaymentsOpen={setPremiumPaymentsOpen}
            setPremiumDiaryEatOpen={setPremiumDiaryEatOpen}
            setPremiumDiaryMoveOpen={setPremiumDiaryMoveOpen}
            groupsEatEditing={groupsEatEditing}
            setGroupsEatEditing={setGroupsEatEditing}
            groupsMoveEditing={groupsMoveEditing}
            setGroupsMoveEditing={setGroupsMoveEditing}
            newEatGroup={newEatGroup}
            setNewEatGroup={setNewEatGroup}
            newMoveGroup={newMoveGroup}
            setNewMoveGroup={setNewMoveGroup}
            consentAsked={consentAsked}
            setPremiumNutriAdviceOpen={setPremiumNutriAdviceOpen}
            setNewEpisodeWarningOpen={setNewEpisodeWarningOpen}
            setPremiumNutriAppointmentOpen={setPremiumNutriAppointmentOpen}
            setPremiumMeasuresWeightOpen={setPremiumMeasuresWeightOpen}
            setPremiumQuestionnaireOpen={setPremiumQuestionnaireOpen}
            setPremiumKnowledgeOpen={setPremiumKnowledgeOpen}
          />)}
        </Grid>
        <Grid item xs={12} md={4}>
          {(login?.settings?.userdetail_widgets.right_col || []).map(cl => <CoachUserWidgetsBaseMapper
            cl={cl}
            object={object}
            setPremiumEhealthOpen={setPremiumEhealthOpen}
            setPremiumZorgmailOpen={setPremiumZorgmailOpen}
            setPremiumNutriMailOpen={setPremiumNutriMailOpen}
            setEhealthInitOpen={setEhealthInitOpen}
            setZorgmailInitOpen={setZorgmailInitOpen}
            objectRefetch={objectRefetch}
            mutationCustomAction={mutationCustomAction}
            passResetLink={passResetLink}
            passResetEmail={passResetEmail}
            setPremiumPaymentsOpen={setPremiumPaymentsOpen}
            setPremiumDiaryEatOpen={setPremiumDiaryEatOpen}
            setPremiumDiaryMoveOpen={setPremiumDiaryMoveOpen}
            groupsEatEditing={groupsEatEditing}
            setGroupsEatEditing={setGroupsEatEditing}
            groupsMoveEditing={groupsMoveEditing}
            setGroupsMoveEditing={setGroupsMoveEditing}
            newEatGroup={newEatGroup}
            setNewEatGroup={setNewEatGroup}
            newMoveGroup={newMoveGroup}
            setNewMoveGroup={setNewMoveGroup}
            consentAsked={consentAsked}
            setPremiumNutriAdviceOpen={setPremiumNutriAdviceOpen}
            setNewEpisodeWarningOpen={setNewEpisodeWarningOpen}
            setPremiumNutriAppointmentOpen={setPremiumNutriAppointmentOpen}
            setPremiumMeasuresWeightOpen={setPremiumMeasuresWeightOpen}
            setPremiumQuestionnaireOpen={setPremiumQuestionnaireOpen}
            setPremiumKnowledgeOpen={setPremiumKnowledgeOpen}
          />)}
        </Grid>
      </>}









      {!login?.settings?.userdetail_widgets && <>
        <Grid item xs={12} md={4}>
          <CoachUserWidgetsPictureAndTags
            object={object}
            setPremiumEhealthOpen={setPremiumEhealthOpen}
            setPremiumZorgmailOpen={setPremiumZorgmailOpen}
            setPremiumNutriMailOpen={setPremiumNutriMailOpen}
            setEhealthInitOpen={setEhealthInitOpen}
            setZorgmailInitOpen={setZorgmailInitOpen}
            objectRefetch={objectRefetch}
          />

          {object?.type === "User::User" && <CoachUserWidgetsConsentInformation
            object={object}
          />}

          {object?.type === "User::User" && !!object.consent_status?.enabled && object.email.indexOf("accountclosed") < 0 && <CoachUserWidgetsAccountManagement
            object={object}
            mutationCustomAction={mutationCustomAction}
            passResetLink={passResetLink}
            passResetEmail={passResetEmail}
          />}

          {object?.type === "User::User" && <CoachUserWidgetsNotificationInformation
            object={object}
          />}

          {object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsCoursesSmall
            object={object}
            setPremiumKnowledgeOpen={setPremiumKnowledgeOpen}
          />}

          {object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsMollieLinksSmall
            object={object}
            setPremiumPaymentsOpen={setPremiumPaymentsOpen}
          />}

          <CoachUserWidgetsWeightTrigger
            object={object}
            mutationCustomAction={mutationCustomAction}
          />

        </Grid>




        <Grid item xs={12} md={4}>

          <CoachUserWidgetsDetailsBasic
            object={object}
          />
          <CoachUserWidgetsDetailsContact
            object={object}
          />
          {object?.type === "User::User" && <CoachUserWidgetsDetailsExtra
            object={object}
          />}

          {object?.type === "User::User" && <CoachUserWidgetsAppointmentsSmall
            object={object}
            setPremiumNutriAppointmentOpen={setPremiumNutriAppointmentOpen}
          />}

          {object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsCommunicationSmall
            source="nutri"
            object={object}
            setPremiumNutriMailOpen={setPremiumNutriMailOpen}
          />}

          {object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsCommunicationSmall
            source="ehealth"
            object={object}
            setPremiumEhealthOpen={setPremiumEhealthOpen}
            setEhealthInitOpen={setEhealthInitOpen}
          />}

          {object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsCommunicationSmall
            source="zorg"
            object={object}
            setPremiumZorgmailOpen={setPremiumZorgmailOpen}
            setZorgmailInitOpen={setZorgmailInitOpen}
          />}

        </Grid>





        <Grid item xs={12} md={4}>

          {object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsFileSmall
            object={object}
            mutationCustomAction={mutationCustomAction}
            consentAsked={consentAsked}
            setPremiumNutriAdviceOpen={setPremiumNutriAdviceOpen}
            setNewEpisodeWarningOpen={setNewEpisodeWarningOpen}
          />}

          {object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsBasicIntake
            object={object}
          />}

          {object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsBasicTreatment
            object={object}
          />}

          {object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsBasicAdvice
            object={object}
          />}

          {object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsBasicMeasureUploads
            object={object}
          />}

          {object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsBasicAdviceUploads
            object={object}
          />}



          {object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsTimeline
            object={object}
          />}

          {object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsBasicSleep
            object={object}
          />}


          {object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsWorkshops
            object={object}
          />}

          {object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsStatus
            object={object}
          />}

          {object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsInternalComment
            object={object}
            objectRefetch={objectRefetch}
          />}
          {object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsDiarySmall
            object={object}
            mutationCustomAction={mutationCustomAction}
            setPremiumDiaryEatOpen={setPremiumDiaryEatOpen}
            setPremiumDiaryMoveOpen={setPremiumDiaryMoveOpen}
            groupsEatEditing={groupsEatEditing}
            setGroupsEatEditing={setGroupsEatEditing}
            groupsMoveEditing={groupsMoveEditing}
            setGroupsMoveEditing={setGroupsMoveEditing}
            newEatGroup={newEatGroup}
            setNewEatGroup={setNewEatGroup}
            newMoveGroup={newMoveGroup}
            setNewMoveGroup={setNewMoveGroup}
          />}

          {object?.type === "User::User" && <CoachUserWidgetsMeasuresSmall
            object={object}
            setPremiumMeasuresWeightOpen={setPremiumMeasuresWeightOpen}
          />}

          {!login?.is_secretary && <CoachUserWidgetsQuestionnairesSmall
            object={object}
            setPremiumQuestionnaireOpen={setPremiumQuestionnaireOpen}
          />}

          {object?.type !== "User::User" && !login?.is_secretary && <CoachUserWidgetsCoursesSmall
            object={object}
            setPremiumKnowledgeOpen={setPremiumKnowledgeOpen}
          />}

          {object?.type !== "User::User" && !login?.is_secretary && <CoachUserWidgetsMollieLinksSmall
            object={object}
            setPremiumPaymentsOpen={setPremiumPaymentsOpen}
          />}

        </Grid>



        {object?.type === "User::User" && !object.merge_pending && <Grid item xs={12} sx={{textAlign: 'center'}}>
          <Button
            label={t("coach.submenu.detail.merge_request", "Deze gebruiker is dubbel")}
            id='goto_merge'
            contained
            secondary
            onClick={(v) => {
              navigate(`/user/${object.id}/merge_request`);
            }}
            sx={{marginTop: 2}}
          />
        </Grid>}




        {object?.type === "User::User" && !object.consent_status?.is_blocked && <Grid item xs={12} sx={{textAlign: 'center'}}>
          <Button
            label={t("coach.submenu.detail.unlink_from_practice", "Deze gebruiker ontlinken")}
            id='unlink_user'
            text
            secondary
            destroyBtn
            startIcon={<LinkOffIcon />}
            onClick={(v) => {
              mutationCustomAction.mutate({
                formData: {
                  object: 'user',
                  class_action: 'custom_api_unlink_from_practice',
                  id: object?.id,
                  practice_id: (login?.practice_id || currentPractice?.id)
                },
                unlink: true
              });
            }}
            sx={{marginTop: 2}}
          />
        </Grid>}
        {object?.type === "User::User" && !!object.consent_status?.is_blocked && <Grid item xs={12} sx={{textAlign: 'center'}}>
          <Button
            label={t("coach.submenu.detail.ununlink_from_practice", "Deze gebruiker terug linken")}
            id='link_user'
            text
            startIcon={<LinkIcon />}
            onClick={(v) => {
              mutationCustomAction.mutate({
                formData: {
                  object: 'user',
                  class_action: 'custom_api_unlink_from_practice',
                  id: object?.id,
                  practice_id: (login?.practice_id || currentPractice?.id),
                  reverse: 1
                },
                unlink: true
              });
            }}
            sx={{marginTop: 2}}
          />
        </Grid>}
      </>}










    </Grid>}
    
    <SnackSaved open={savedOpen} setOpen={setSavedOpen} />
    <Premium
      open={premiumEhealthOpen}
      setOpen={(b) => {
        setPremiumEhealthOpen(b);
      }}
      mode="ehealth"
    />
    <Premium
      open={premiumZorgmailOpen}
      setOpen={(b) => {
        setPremiumZorgmailOpen(b);
      }}
      mode="zorg_mail"
    />
    <Premium
      open={premiumNutriAdviceOpen}
      setOpen={(b) => {
        setPremiumNutriAdviceOpen(b);
      }}
      mode="nutri_advice"
    />
    <Premium
      open={premiumNutriMailOpen}
      setOpen={(b) => {
        setPremiumNutriMailOpen(b);
      }}
      mode="nutri_mail"
    />
    <Premium
      open={premiumDiaryEatOpen}
      setOpen={(b) => {
        setPremiumDiaryEatOpen(b);
      }}
      mode="nutri_diary_eat"
    />
    <Premium
      open={premiumDiaryMoveOpen}
      setOpen={(b) => {
        setPremiumDiaryMoveOpen(b);
      }}
      mode="nutri_diary_move"
    />
    <Premium
      open={premiumNutriAppointmentOpen}
      setOpen={(b) => {
        setPremiumNutriAppointmentOpen(b);
      }}
      mode="nutri_appointment"
    />
    <Premium
      open={premiumMeasuresWeightOpen}
      setOpen={(b) => {
        setPremiumMeasuresWeightOpen(b);
      }}
      mode="measures_weight"
    />
    <Premium
      open={premiumQuestionnaireOpen}
      setOpen={(b) => {
        setPremiumQuestionnaireOpen(b);
      }}
      mode="questionnaire"
    />
    <Premium
      open={premiumPaymentsOpen}
      setOpen={(b) => {
        setPremiumPaymentsOpen(b);
      }}
      mode="payments"
    />
    <Premium
      open={premiumKnowledgeOpen}
      setOpen={(b) => {
        setPremiumKnowledgeOpen(b);
      }}
      mode="knowledge"
    />

    {/* <Confirm
      open={invitation}
      setOpen={setInvitation}
      title={t("coach.questionnaires.send_invite_dialog.title")}
      content={t("coach.questionnaires.send_invite_dialog.content")}
      execute={() => {
        if (!!object && !!activeQ) {
          mutationSave.mutate({
            formData: {
              object: 'questionnaire_result',
              fields: ['id'],
              id: ((object.questionnaire_results || []).filter(fff => activeQ.id === fff.questionnaire_id)[0] || {}).id,
              ob: {
                id: ((object.questionnaire_results || []).filter(fff => activeQ.id === fff.questionnaire_id)[0] || {}).id,
                user_id: object.id,
                questionnaire_id: activeQ.id,
                practice_id: currentPractice?.id,
                do_invite: true
              }
            }
          });
        }
      }}
    /> */}


    <Base
      name="alert"
      hidden={!ehealthInitOpen}
      title={t("general.ehealth.not_inited_title")}
      content={<Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography>{t("general.ehealth.not_inited_content")}</Typography>
        </Grid>
      </Grid>}
      actions={<DialogActions sx={{borderTop: '1px solid transparent', borderColor: theme.palette.primary.main}}>
        <Btn autoFocus onClick={() => {setEhealthInitOpen(false);}}>{t("general.confirm.actions.cancel")}</Btn>
        <Btn onClick={(e) => {
          navigate("/settings", {state: {tab: 4}});
          setEhealthInitOpen(false);
        }}>{t("general.ehealth.not_inited_action_settings")}</Btn>
      </DialogActions>}
      open={ehealthInitOpen}
      setOpen={setEhealthInitOpen}
    />

    <Base
      name="alert"
      hidden={!zorgmailInitOpen}
      title={t("general.zorgmail.not_inited_title")}
      content={<Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography>{t("general.zorgmail.not_inited_content")}</Typography>
        </Grid>
      </Grid>}
      actions={<DialogActions sx={{borderTop: '1px solid transparent', borderColor: theme.palette.primary.main}}>
        <Btn autoFocus onClick={() => {setZorgmailInitOpen(false);}}>{t("general.confirm.actions.cancel")}</Btn>
        <Btn onClick={(e) => {
          navigate("/settings", {state: {tab: 4}});
          setEhealthInitOpen(false);
        }}>{t("general.zorgmail.not_inited_action_settings")}</Btn>
      </DialogActions>}
      open={zorgmailInitOpen}
      setOpen={setZorgmailInitOpen}
    />

    <Base
      name="alert"
      hidden={!newEpisodeWarningOpen}
      title={t("general.episodes.warning_title")}
      content={<Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography>{t("general.episodes.warning_content")}</Typography>
        </Grid>
      </Grid>}
      actions={<DialogActions sx={{borderTop: '1px solid transparent', borderColor: theme.palette.primary.main}}>
        <Btn autoFocus onClick={() => {setNewEpisodeWarningOpen(false);}}>{t("general.confirm.actions.cancel")}</Btn>
        <Btn onClick={(e) => {
          mutationCustomAction.mutate({
            formData: {
              object: 'user',
              class_action: 'custom_api_increase_episode',
              id: object?.id,
              practice_id: (login?.practice_id || currentPractice?.id)
            },
            mfa: true
          });
          setNewEpisodeWarningOpen(false);
        }}>{t("general.episodes.create_new_episode_cta")}</Btn>
      </DialogActions>}
      open={newEpisodeWarningOpen}
      setOpen={setNewEpisodeWarningOpen}
    />

    {!!questionnaireResult && <CoachShowQuestionnaire
      open={qResultOpen}
      setOpen={setQResultOpen}
      object={questionnaireResult}
      setSavedOpen={(b) => {
        setSavedOpen(b);
        objectRefetch();
        questionnaireResultRefetch();
      }}
    />}
  </Page>;
}
